import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const certifications = [
  {
    id: 1,
    name: 'FCA Regulated',
    description: 'Authorized by the Financial Conduct Authority',
    icon: 'Shield',
    badge: "https://img.rocket.new/generatedImages/rocket_gen_img_196ae556d-1763467927607.png",
    badgeAlt: 'FCA Financial Conduct Authority regulatory badge with blue and white official seal'
  },
  {
    id: 2,
    name: 'PCI DSS Compliant',
    description: 'Payment Card Industry Data Security Standard',
    icon: 'CreditCard',
    badge: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7601f75-1763467925378.png",
    badgeAlt: 'PCI DSS compliance certification badge with security shield and checkmark'
  },
  {
    id: 3,
    name: 'ISO 27001 Certified',
    description: 'Information Security Management System',
    icon: 'Award',
    badge: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf236aa4-1763467925428.png",
    badgeAlt: 'ISO 27001 certification badge with international standards organization logo'
  }];


  const securityFeatures = [
  {
    icon: 'Lock',
    title: '256-bit SSL Encryption',
    description: 'Bank-level security for all data transmission'
  },
  {
    icon: 'Eye',
    title: 'Real-time Monitoring',
    description: 'Advanced fraud detection and prevention'
  },
  {
    icon: 'UserCheck',
    title: 'Identity Verification',
    description: 'Multi-layer KYC and AML compliance'
  },
  {
    icon: 'Database',
    title: 'Secure Data Storage',
    description: 'Encrypted storage with regular security audits'
  }];


  const statistics = [
  {
    value: '2M+',
    label: 'Trusted Customers',
    icon: 'Users'
  },
  {
    value: '$50B+',
    label: 'Transferred Safely',
    icon: 'TrendingUp'
  },
  {
    value: '99.9%',
    label: 'Uptime Guarantee',
    icon: 'Clock'
  },
  {
    value: '180+',
    label: 'Countries Served',
    icon: 'Globe'
  }];


  return (
    <div className="space-y-6">
      {/* Regulatory Certifications */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center space-x-2">
          <Icon name="Award" size={20} />
          <span>Regulatory Compliance</span>
        </h3>
        
        <div className="space-y-4">
          {certifications?.map((cert) =>
          <div key={cert?.id} className="flex items-center space-x-4 p-3 bg-muted rounded-lg">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={cert?.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-foreground">{cert?.name}</h4>
                <p className="text-sm text-muted-foreground">{cert?.description}</p>
              </div>
              <div className="flex-shrink-0">
                <Image
                src={cert?.badge}
                alt={cert?.badgeAlt}
                className="w-16 h-8 object-contain" />

              </div>
            </div>
          )}
        </div>
      </div>
      {/* Security Features */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center space-x-2">
          <Icon name="Shield" size={20} />
          <span>Security Features</span>
        </h3>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {securityFeatures?.map((feature, index) =>
          <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                <Icon name={feature?.icon} size={16} className="text-success" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Trust Statistics */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center space-x-2">
          <Icon name="TrendingUp" size={20} />
          <span>Trusted Worldwide</span>
        </h3>
        
        <div className="grid grid-cols-2 gap-4">
          {statistics?.map((stat, index) =>
          <div key={index} className="text-center p-3 bg-muted rounded-lg">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Icon name={stat?.icon} size={16} className="text-primary" />
              </div>
              <div className="text-xl font-bold text-foreground">{stat?.value}</div>
              <div className="text-xs text-muted-foreground">{stat?.label}</div>
            </div>
          )}
        </div>
      </div>
      {/* Data Protection Notice */}
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-medium text-primary mb-1">Data Protection Notice</h4>
            <p className="text-xs text-primary/80">
              Your personal information is protected under GDPR and other applicable data protection laws. 
              We use your data solely for account verification, compliance, and service provision. 
              You have the right to access, correct, or delete your data at any time.
            </p>
          </div>
        </div>
      </div>
      {/* Contact Support */}
      <div className="text-center space-y-2">
        <p className="text-sm text-muted-foreground">
          Questions about our security or registration process?
        </p>
        <div className="flex items-center justify-center space-x-4 text-sm">
          <a
            href="mailto:support@moneytransferpro.com"
            className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-colors">

            <Icon name="Mail" size={14} />
            <span>Email Support</span>
          </a>
          <a
            href="tel:+1-800-123-4567"
            className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-colors">

            <Icon name="Phone" size={14} />
            <span>Call Us</span>
          </a>
        </div>
      </div>
    </div>);

};

export default TrustSignals;